// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_b4-0";
export var optionCard = "_b4-1";